import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store/geomoverStore'
//
// import GeoMoverDB from '@/db/indexeddb'
// import { EventBus } from './eventBus'
import Filters from './filter/Filters'
import ToggleButton from 'vue-js-toggle-button'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import './css/index.css'
// Local plugins
import GlobalModal from './plugins/Modal/Modal.js'
import Logger from '@/plugins/Logger'

Vue.config.productionTip = false

Vue.use(ToggleButton)
Vue.use(Filters)
Vue.use(GlobalModal)
Vue.use(Logger, store)

Vue.component('v-select', vSelect)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

/*
<!-- Here assets start - ->
<script type="text/javascript" charset="UTF-8" src="https://js.api.here.com/v3/3.1/mapsjs-core.js"></script>
<script type="text/javascript" charset="UTF-8" src="https://js.api.here.com/v3/3.1/mapsjs-service.js"></script>
<script type="text/javascript" charset="UTF-8" src="https://js.api.here.com/v3/3.1/mapsjs-mapevents.js"></script>
<script type="text/javascript" charset="UTF-8" src="https://js.api.here.com/v3/3.1/mapsjs-ui.js"></script>
<script type="text/javascript" charset="UTF-8" src="https://js.api.here.com/v3/3.1/mapsjs-clustering.js"></script>
<script type="text/javascript" charset="UTF-8" src="https://js.api.here.com/v3/3.1/mapsjs-data.js"></script>
<link rel="stylesheet" type="text/css" href="https://js.api.here.com/v3/3.1/mapsjs-ui.css" />
<! -- Here assets end -->
*/
